import config from "appConfig";
import { ControlsToggleExtraContent, LayoutComponent } from "packages/lesson/dist/@types";

import deg0 from "./air-ne/0deg";
import deg5 from "./air-ne/5deg";
import deg10 from "./air-ne/10deg";
import deg15 from "./air-ne/15deg";
import deg20 from "./air-ne/20deg";
import thetaCrit from "./air-ne/thetaCrit";
import deg25 from "./air-ne/25deg";
import deg30 from "./air-ne/30deg";
import deg35 from "./air-ne/35deg";
import deg40 from "./air-ne/40deg";
import deg45 from "./air-ne/45deg";
import deg50 from "./air-ne/50deg";
import deg55 from "./air-ne/55deg";
import deg60 from "./air-ne/60deg";
import deg65 from "./air-ne/65deg";
import deg70 from "./air-ne/70deg";
import deg75 from "./air-ne/75deg";
import deg80 from "./air-ne/80deg";
import deg85 from "./air-ne/85deg";
import deg89_99 from "./air-ne/89-99deg";

const staticExtraContent: ControlsToggleExtraContent = [
  {
    type: "image",
    options: {
      src: `${config.ASSETS_URL}/01/12/principle/air-ne-badge.svg`,
      styles: {
        width: "350px",
        height: "90px",
      },
    },
  },
];

const component: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "controlsToggleExtraContent",
      options: {
        controlsPosition: "bottom",
        controls: [
          {
            type: "dropdown",
            options: {},
            items: [
              { name: "Angle of incidence θ = 0°" },
              { name: "Angle of incidence θ = 5°" },
              { name: "Angle of incidence θ = 10°" },
              { name: "Angle of incidence θ = 15°" },
              { name: "Angle of incidence θ = 20°" },
              { name: "Angle of incidence θ = θ<sub>cr</sub> = 21.497°" },
              { name: "Angle of incidence θ = 25°" },
              { name: "Angle of incidence θ = 30°" },
              { name: "Angle of incidence θ = 35°" },
              { name: "Angle of incidence θ = 40°" },
              { name: "Angle of incidence θ = 45°" },
              { name: "Angle of incidence θ = 50°" },
              { name: "Angle of incidence θ = 55°" },
              { name: "Angle of incidence θ = 60°" },
              { name: "Angle of incidence θ = 65°" },
              { name: "Angle of incidence θ = 70°" },
              { name: "Angle of incidence θ = 75°" },
              { name: "Angle of incidence θ = 80°" },
              { name: "Angle of incidence θ = 85°" },
              { name: "Angle of incidence θ = 90°" },
            ],
          },
        ],
        extraContent: [
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
          staticExtraContent,
        ],
        components: [
          deg0,
          deg5,
          deg10,
          deg15,
          deg20,
          thetaCrit,
          deg25,
          deg30,
          deg35,
          deg40,
          deg45,
          deg50,
          deg55,
          deg60,
          deg65,
          deg70,
          deg75,
          deg80,
          deg85,
          deg89_99,
        ],
      },
    },
  },
];

export default component;
